import React from 'react'
import { Modal } from 'react-bootstrap'

import { useInitDispatch } from '../util/hooks'
import { openCollection } from '../actions/documentation'

export const Documentation = ({
  showSide,
  collection,
  selectedSection,
  selectSection
}) => {
  const scrollD = ele => {
    document.getElementById('scrolltarget').scrollTop = document.getElementById(
      ele
    ).offsetTop
  }
  const leftPane = () => {
    if (showSide) {
      return (
        <div className="col-xs-3 menu-left-pane">
          <ul className="documentation-nav">
            {collection?.sections?.map(s => (
              <li key={s.id} className="toplevelitem">
                <a
                  href="#"
                  onClick={() => selectSection(s.id)}
                  className={s.id === selectedSection.id ? 'selected' : 'unselected'}>
                  {s.name}
                </a>
                <ul
                  className={`subsection ${
                    s.id === selectedSection.id ? 'open' : 'closed'
                  }`}>
                  {s.subSections?.map(ss => (
                    <li key={ss.id}>
                      <a href="#" onClick={() => scrollD(`subsection${ss.id}`)}>
                        {ss.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      )
    }
  }
  const rightClass = () => {
    if (showSide) {
      return 'col-xs-9 content-right-pane'
    }

    return ''
  }

  return (
    <div className="row helpcontainer">
      {leftPane()}
      <div className={rightClass()} id="scrolltarget">
        <h3 id={`section${selectedSection.id}`}>{selectedSection.name}</h3>
        <div>
          <span dangerouslySetInnerHTML={{ __html: selectedSection.text }}></span>
        </div>
        {selectedSection.subSections?.map(ss => (
          <div>
            <h4 id={`subsection${ss.id}`}>{ss.name}</h4>
            <div>
              <span dangerouslySetInnerHTML={{ __html: ss.text }}></span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export const DocumentationModal = ({
  collectionId,
  modalOpen,
  modalClose,
  collection,
  selectedSection,
  selectSection
}) => {
  useInitDispatch(openCollection(collectionId), [collectionId])

  return (
    <Modal show={modalOpen} onHide={modalClose} dialogClassName="fullscreen-modal">
      <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
        <button type="button" className="close" aria-label="Close" onClick={modalClose}>
          <span aria-hidden="true">×</span>
        </button>
        <Modal.Title>{collection.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Documentation
          collection={collection}
          showSide={true}
          selectedSection={
            selectedSection
              ? collection.sections.find(s => s.id === selectedSection)
              : (collection.sections || [])[0] || {}
          }
          selectSection={selectSection}
        />
      </Modal.Body>
    </Modal>
  )
}
